<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12 class="pt-10">
        <h1>Thank you for becoming a Corporate Member.</h1>

        <v-row>
          <v-col cols="6">
            <p class="mt-8">
              The Outdoor Wire has been providing news and information about the
              outdoor industry for 20 years and we look forward to working with
              your company to get the word out about your business.
            </p>

            <p>
              An invoice will be sent to you soon that will cover your annual
              fee for your company’s Corporate Membership.
            </p>

            <p>
              Below you will see submission requirements for press releases to
              The Outdoor Wire Digital Network and editor contact information
              for the individual wires.
            </p>

            <p>Thanks again for becoming a Corporate Member,</p>

            <p>
              <i>Alex Miceli & Jim Shepherd</i>
            </p>

            <v-divider class="my-6"></v-divider>

            <h3>Submission Requirement for The Outdoor Wire Digital Network</h3>

            <p>
              Because the Outdoor Wire Digital Network reviews thousands of
              press releases a year and in an attempt to provide timeliness and
              100% accuracy on all press release submissions, the following
              policies and procedures should be adhered to moving forward.
            </p>

            <p>
              If these policies and procedures are not followed, the Outdoor
              Wire Digital Network cannot guarantee the press release will run
              on time.
            </p>

            <ol>
              <li>
                All press release submissions will need the name of the
                subscribing company, current invoice number, year and wire
                designation included in the subject line of the e-mail
                submission. As an example,
                <b>Joe’s Outdoor Emporium - 2222-2020 (TOW/SW/FW)</b>
                <br />The designation for the individual wires is (Outdoor Wire – TOW,
                Shooting Wire – SW, Tactical Wire – TW, Fishing Wire – FW,
                Birding Wire – BW, Archery Wire – AW, AirGun Wire – AG, Dealer
                Wire – DW and Hunting Wire – HW).
              </li>
              <li>
                Only one press release should be included in a submission. Two
                press releases require two separate e-mail submissions.
              </li>
              <li>
                The only acceptable formats for submissions are Microsoft Word,
                Apple Pages, text document or text embedded in the e-mail
                itself. Product specs should
                <b>NOT</b> be provided as embedded
                excel tables.
              </li>
              <li>
                The submission should not have any special formatting, nor
                should photos or logos be embedded in the document. All photos
                and logos should be attached separately in the e-mail
                submission. Logos in a square format is preferable.
                <b>Only jpeg or jpg formats for photos are acceptable.</b>
              </li>
              <li>
                Only one logo and photo should be submitted, multiple logos and
                photos will not be included,
                <b>web resolution images only.</b>
              </li>
              <li>
                All product specs should be provided in a list in one of the
                acceptable formats, Microsoft Word, Apple Pages, text document
                or text embedded in the e-mail itself.
              </li>
              <li>In all submissions, a preferred headline should be included.</li>
              <li>
                All press releases are sent to the subscriber base of the
                particular newsletter, if distribution restrictions are
                necessary, they need to be clearly indicated in the top of the
                newsletter, before the submission.
              </li>
              <li>
                Provide contact information that includes name, e-mail address
                and mobile phone number for questions.
              </li>
              <li>
                Provide links to the company website and URL for links to press
                release information on the company website.
              </li>
              <li>Corporate Memberships run on a calendar year basis (Jan – Dec.).</li>
            </ol>

            <v-divider class="my-6"></v-divider>

            <p>
              The following is the contact information for the editors for
              questions about your submissions.
            </p>

            <p>
              Thank you for believing in in the Outdoor Wire Digital Network as
              we enter our 20th year serving the Outdoor Industry.
            </p>

            <p>
              Publisher - Jim Shepherd –
              <a
                href="shepherdproductions@mac.com"
              >shepherdproductions@mac.com</a>
              <br />Co-Publisher – Alex Miceli –
              <a href="alex@theoutdoorwire.com">alex@theoutdoorwire.com</a>
              <br />Outdoor & Shooting Wires –
              <a href="shepherdproductions.com">shepherdproductions.com</a>
              <br />Archery Wire - Michelle Scheuermann -
              <a
                href="michelle@bulletproofcomm.com"
              >michelle@bulletproofcomm.com</a>
              <br />Tactical Wire - Rich Grassi -
              <a
                href="rich@thetacticalwire.com"
              >rich@thetacticalwire.com</a>
              <br />Dealer Wire - Paul Erhardt -
              <a
                href="paul@erhardtandassociates.com"
              >paul@erhardtandassociates.com</a>
              <br />AirGun Wire – Tom McHale -
              <a href="tommchale@me.com">tommchale@me.com</a>
              <br />Birding Wire – Paul Konrad -
              <a
                href="paul@wildlifeadventures.biz"
              >paul@wildlifeadventures.biz</a>
              <br />Hunting Wire – Jay Pinsky -
              <a href="jamespinsky@yahoo.com">jamespinsky@yahoo.com</a>
              <br />
            </p>

            <p>
              Alex Miceli - (804) 245-2829 - If you have any questions or need
              assistance.
            </p>

            <p>
              Press Release Submissions –
              <a href="pr@theoutdoorwire.com">pr@theoutdoorwire.com</a>
              <br />Advertising Submissions –
              <a href="ads@theoutdoorwire.com">ads@theoutdoorwire.com</a>
            </p>

            <p>
              Subsequent annual invoices will be automatically generated in
              November/December for the following calendar year.
            </p>

            <p>Revised – April 8, 2020</p>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "signupComplete",
};
</script>
